<template>
    <div class="wrap-content customer-section">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-12">
                    <h2>Notifications</h2>
                </div>
                <div class="col-md-12 filter-all-customers">
                    <div class="row">

                        <div class="col-md-8">
                            <base-search placeholder="Search" @keyword="getKeyword"></base-search>
                        </div>
                        <div class="col-md-2">
                            <b-form-group>
                                <button
                                        class="btn btn-primary"
                                        type="submit"
                                        :class="
                                                loading && showPageLoader
                                                    ? 'disabled'
                                                    : ''
                                            "
                                        @click="apply"
                                >
                                    <span class="btn-text">Apply</span>
                                    <span class="loader"></span>
                                </button>
                            </b-form-group>
                        </div>
                        <div class="col-sm-2">
                            <b-button
                                    v-if="hasScopes('manage-notifications')"
                                    v-b-modal.add-notification-popup
                                    class="btn secondary-add-btn"
                                    variant="secondary"
                                    type="submit"
                                    :class="{
                                           'button-disabled': !hasScopes(
                                               'manage-notifications'
                                           ),
                                       }"
                            >
                                       <span class="btn-text"
                                       >Create</span
                                       >
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="[
                                'table-section',
                                'table-min-width',
                                {
                                    'overflow-hidden': !data.length && !showPageLoader,
                                },
                            ]">
            <b-table :items="data" :fields="fields" no-local-sorting :tbody-tr-class="rowClass"
                @sort-changed="sortingChanged">


                <template slot="title" slot-scope="data">
                    <div class="action-flex" :class="data.item.status == 'processing'
                                ? 'disable-color disable'
                                : ''
                                ">
                        <span>
                            {{ data.item.title }}
                        </span>
                    </div>
                </template>

                <template slot="description" slot-scope="data">
                    <div class="textElipses">
                        {{
                                data.item.description
                            }}
                    </div>
                </template>
                <!-- Join Date -->
                <template slot="createdAt" slot-scope="data">
                    <!--{{ data.item.createdAt | moment('MMM D, YYYY h:mm a') }}-->
                    <span :class="data.item.status == 'processing' ? 'gray-text' : ''
                                ">{{
                                data.item.createdAt | moment('MMM D, YYYY h:mm a')
                            }}</span>
                </template>
                <template slot="status" slot-scope="data">
                    <base-status :status-type="data.item.status" class="fa fa-user-time"></base-status>
                </template>

                <template slot="action" slot-scope="data">
                    <div class="action-container">
                        <div class="action-review">
                            <!-- <base-action v-b-tooltip.hover icon="icon-edit" title="Edit Profile" :class="data.item.status == 'processing'
                                ? 'disable-color disable'
                                : ''
                                "
                                         @click="
                                selectedRecord(data.item)
                                $bvModal.show('add-notification-popup')
                            "
                            ></base-action> -->
                            <base-action v-b-tooltip.hover 
                                icon="icon-eye-view" title="View" @click="
                                openDetails(data.item)
                                "></base-action>
                        </div>

                        <div class="action-review">
                             <!--if action archive-->
                            <base-action
                            v-if="data.item.status == 'inactive'"
                            v-b-tooltip.hover
                            icon="icon-done"
                            title="Activate"
                            :class="
                            data.item.status == 'processing'
                            ? 'disable-color disable'
                            : ''
                            "
                            @click="
                            selectedRecord(data.item)
                            updateStatusPopup('active')
                            "
                            ></base-action>
                            <!-- if action activate -->
                            <base-action v-else v-b-tooltip.hover :class="data.item.status == 'processing'
                                ? 'disable-color disable'
                                : ''
                                " icon="icon-cross-with-circle" title="In-activate" @click="
                                selectedRecord(data.item)
                            updateStatusPopup('inactive')
                                "></base-action>
                                                        <div class="action-review">

                                 <base-action v-b-tooltip.hover 
                                icon="icon-trash" title="Delete" @click="
                                selectedRecord(data.item)
                                updateStatusPopup('delete')
                                "></base-action>
                                </div>
                        </div>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner v-if="!data.length && showPageLoader"></base-table-spinner>
            <div v-else></div>
            <!-- When record not found -->
            <base-no-record-found v-if="!data.length && !showPageLoader"></base-no-record-found>
            <div v-else></div>
        </div>

        <base-records path="configurations/getAllNotifications" :query="query" :reset="reset" :show-pagination="true"></base-records>
   
        <status-confirmation-popup ref="status-confirmation-popup" record-type="customer" :description="statusDescription"
            @update-status="updateStatus(statusToUpdate)"></status-confirmation-popup>

        <add-notification-popup
                :title="title"
                :button-text="buttonText"
        ></add-notification-popup>
        <notification-details-popup
                title="Notification"
                :description=selectedDescription
                 >
        </notification-details-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
import StatusConfirmationPopup from "../../components/popups/StatusConfirmationPopup";
import AddNotificationPopup from "../../components/popups/AddNotificationPopup";
import NotificationDetailsPopup from '../../components/popups/NotificationDetailsPopup.vue';

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        AddNotificationPopup,
        StatusConfirmationPopup,
        NotificationDetailsPopup
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            APP_COUNTRY: process.env.VUE_APP_COUNTRY,
            APP_URL: process.env.VUE_APP_API_URL,
            statusDescription: "",
            statusToUpdate: "",
            title:"Add Notification",
            buttonText:"Create",
            selectedDescription:"",
            fields: {
                title: {
                    label: 'Title',
                    sortable: false,
                },
                // link: {
                //     label: 'Link',
                //     sortable: false,
                // },

                description: {
                    label: 'Description',
                    sortable: false,
                },
                type: {
                    label: 'Type',
                    sortable: false,
                },
                category: {
                    label: 'Category',
                    sortable: false,
                },
                createdAt: {
                    label: 'Created On',
                    sortable: true,
                    tdAttr: {
                        dataname: 'createdAt',
                    },
                },
                expiresAt: {
                    label: 'Expiry Date',
                    sortable: true,
                    tdAttr: {
                        dataname: 'expiresAt',
                    },
                },
                status: {
                    label: 'STATUS',
                    sortable: false,
                    tdClass: 'text-center status-absolute-pos',
                    thClass: 'text-center',
                    tdAttr: {
                        dataname: 'status',
                    },
                },
                action: {
                    label: 'Actions',
                    tdClass: 'w-150px',
                    tdAttr: {
                        dataname: 'Actions',
                    },
                },
            },

            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                status: null,
                sortBy: 'createdAt',
                sortOrder: 'desc',
            },
            reset: new Date().getTime(),
            id: null,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'data',
            'showPageLoader',
            'loading',
            'dataSegmentId',
            'hasScopes',
            'user',
            'selectedItem',
        ]),
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {

    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {

        openDetails(data)
            {
                this.selectedDescription=data.description
                this.$bvModal.show('notification-details-popup')
            },
        async updateStatusPopup(status) {
            this.statusToUpdate = status
            if(status=='delete')
        {
            this.statusDescription = "Are you sure you want to remove this notification?"
        }
           else if (status == 'active') {
                this.statusDescription = "Are you sure you want to activate this notification?"
            }
            else {
                this.statusDescription = "Are you sure you want to in-activate this notification?"
            }
            this.$bvModal.show('status-confirmation-popup')
        },
        async updateStatus(status) {
            try {
                if(status=='delete')
            {
                this.remove()
                return false
            }
                this.$store.commit('setLoading', true)
                const { data } = await request({
                    url: '/configurations/updateNotification',
                    method: 'post',
                    data: {
                        _id: this.selectedItem._id,
                        status: status,
                    },
                })
                if (data) {

                    this.$bvModal.hide('update-user-status-popup')
                    this.$store.commit(
                        'setSuccess',
                        'Status updated successfully'
                    )

                }
                this.$store.commit('setLoading', false)
            } catch (error) {
                console.log('error on updating status:', error)
                this.$store.commit(
                    'setError',
                    'Something went wrong while updating the documents'
                )
                this.$store.commit('setLoading', false)
            }
        },
        async remove() {
            try {
                this.$store.commit('setLoading', true)
                const { data } = await request({
                    url: '/configurations/removeNotification',
                    method: 'post',
                    data: {
                        _id: this.selectedItem._id,
                    },
                })
                if (data) {

                    // this.$bvModal.hide('update-user-status-popup')
                    this.$store.commit(
                        'setSuccess',
                        'Record has been deleted successfully'
                    )

                }
                this.$store.commit('setLoading', false)
            } catch (error) {
                console.log('error on updating status:', error)
                this.$store.commit(
                    'setError',
                    'Something went wrong while updating the documents'
                )
                this.$store.commit('setLoading', false)
            }
        },

        rowClass(item, type) {
            if (item.status == 'inactive' || item.status == 'processing') {
                return 'table-secondary'
            }
        },
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method
        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        }, // End of apply() method

        selectedRecord(record) {
            this.$store.commit('setItem', record)
            this.selectedItem = record
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            this.query.sortBy = ctx.sortBy
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method

    }, // End of Component > mounted
} // End of export default
</script>
